export default __webpack_public_path__ + "static/media/web_screen_engage_fr.25248f9d.png";